export default "__VITE_ASSET__B_rE467g__"